/*
 * Copyright (c) 2020. American Express Company
 */

import $ from 'jquery';
import tippy, { Placement } from 'tippy.js';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/perspective-extreme.css';
import 'tippy.js/animations/scale-extreme.css';
import 'tippy.js/animations/shift-away-extreme.css';
import 'tippy.js/animations/shift-toward-extreme.css';

export interface BwTooltip {
    body: string;
    selector: string;
    title: string;
    animation?: 'perspective-extreme' | 'scale-extreme' | 'shift-away-extreme' | 'shift-toward-extreme';
    arrow?: boolean;
    placement?: Placement;
    url?: string;
}

export const BwTooltipConfiguration: BwTooltip[] = [];

export default class BwTooltipService {
    private static setTooltip(tooltip: BwTooltip, $el: JQuery): void {
        $el.each((index: number, element: HTMLElement) => {
            const learnMoreMarkup = tooltip.url
                ? `<a href="${tooltip.url}" target="_blank" rel="noopener noreferrer">Learn More</a>`
                : '';
            tippy(element, {
                allowHTML: true,
                animation: tooltip.animation || 'scale-extreme',
                arrow: tooltip.arrow || true,
                content: `<b>${tooltip.title}</b><br /><p>${tooltip.body}</p>${learnMoreMarkup}`,
                interactive: true,
                placement: tooltip.placement || 'top'
            });
        });
    }

    /**
     * This should be called within the target component's componentDidUpdate lifecycle block.
     * If a tooltip corresponding to a selector within the component's top-level DOM node is found, this service will
     * set that tooltip.
     * NB: It is important to avoid tooltip collisions through due diligence and specificity when choosing selectors.
     * @param parent {string} A selector corresponding to the target component's uppermost DOM node
     */
    public static setTooltips(parent: string): void {
        BwTooltipConfiguration.forEach((tooltip: BwTooltip) => {
            const $el: JQuery = $(parent).find(tooltip.selector);
            if ($el) this.setTooltip(tooltip, $el);
        });
    }
}
